module.exports = __webpack_public_path__ + "5ddd62c8f6655737c86ce16643a8fb6a.svg";